
export interface fetchWithTokenOptions extends RequestInit {
    token?: string
    lang?: string
}

export async function fetchWithToken(url: string, options: fetchWithTokenOptions = {}): Promise<Response> {
    const headers = new Headers(options.headers)
    if (options?.token) {
        headers.set('Authorization', `Bearer ${options.token}`)
    }
    if (options?.lang) {
        headers.set('Accept-Language', options.lang)
    }
    return fetch(url, {
        ...options,
        headers,
    })
}

export async function fetchJSONWithToken<T>(url: string, options: fetchWithTokenOptions = {}): Promise<T> {
    return fetchWithToken(url, options).then(resp => decodeFetchResponse<T>(resp))
}

export async function decodeFetchResponse<T>(response: Response): Promise<T> {
    const contentType = response.headers.get("Content-Type");
    if (!contentType || !contentType.includes("application/json")) {
        throw new Error('Expected JSON response')
    }
    return await response.json() as T;
}

export function decodeXHRResponse<T>(xhr: XMLHttpRequest): T | undefined {
    if(xhr.responseText==='') {
        return undefined
    }
    var contentType = xhr.getResponseHeader("Content-Type") 
    if (!contentType || !contentType.includes("application/json")) {
        throw new Error('Expected JSON response')
    }
    return JSON.parse(xhr.responseText)
}